import { Outlet, useLocation } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { DashboardContext } from "../Self-Verification Tool/DashboardContext";
import Header from "../common/Header";
import checkUserRole from "./userRoleManger";
import { useTranslation } from "react-i18next";

const AdminLayout = () => {
    const { t, i18n } = useTranslation();
    const [pageName, setPageName] = useState("");
    const location = useLocation();
    const { selectedDashboard } = useContext(DashboardContext);
    const dashboardTranslationKeyMap = {
        "Hitachi Dashboard": "hitachiDashboard",
        "Entity Dashboard": "entityDashboard",
        "Sector Dashboard": "sectorDashboard",
        "Business Unit Dashboard": "businessUnitDashboard",
        "Sub Business Unit Dashboard": "subBusinessUnitDashboard",
        "Region Dashboard": "regionDashboard",
        "Country Dashboard": "countryDashboard"
    };
    const adminPages = [
        {
            path: "levelmanagement",
            page: t("levelManagement")
        },
        {
            path: "templatemanagement",
            page: t("templateManagement")
        },
        {
            path: "slotmanagement",
            page: t("slotManagement")
        },
        {
            path: "picmanagement",
            page: t("picManagement")
        },
        {
            path: "rcmmanagement",
            page: t("rcmManagement")
        },
        {
            path: "dms",
            page: t("documentManagement")
        },
        {
            path: "survey",
            page: t("surveyManagement")
        },
        {
            path: "assessment",
            page: t("assessmentManagement")
        },
        {
            path: "administrator-management",
            page: t("adminManagement")
        },
        {
            path: "organization-management",
            page: t("organizationManagement")
        },
        {
            path: "group-management",
            page: t("distributionListManagement")
        },
        {
            path: "group-details",
            page: t("distributionListDetails")
        },
        {
            path: "dashboard",
            page: t("dashboard")
        },
        {
            path: "external-user-management",
            page: t("externalUserManagement")
        },
        {
            path: "notification-management",
            page: t("notificationManagement")
        },
        {
            path: "domain-management",
            page: t("domainManagement"),
        },
    ];

    useEffect(() => {
        getPageName(location.pathname);
    }, [location, i18n.language]);

    const getPageName = (url) => {
        const page = url.substring(url.lastIndexOf("/") + 1);
        if (page === "dashboard") {
            // Translate selectedDashboard if it matches a known dashboard
            if (selectedDashboard && dashboardTranslationKeyMap[selectedDashboard]) {
                setPageName(t(dashboardTranslationKeyMap[selectedDashboard]));
            } else {
                setPageName(t("dashboard"));
            }
            return;
        }
        adminPages.forEach((item) => {
            if (item.path === page) {
                setPageName(item.page);
            }
        });
    };
    if (checkUserRole()) {
        return <p>{t("accessDenied")}</p>;
    }

    return (
        <div>
            <Header headerName={pageName} />
            <Outlet />
        </div>
    );
};

export default AdminLayout;
